require('./productOffers.scss')

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;
//@components
const { ProductOffersItem } = require('../productOffersItem/productOffersItem');
import OKModal from 'components/commons/OKModal/OKModal'
import RiskProduct from 'components/riskProduct/riskProduct'
import { OKButton } from 'components/commons/OKButton/OKButton';
import { OKMessage } from 'commonsComponents/OKMessage';
import { recordLinkV2 } from 'utilities/tagging'

const modalContent = (data, onOfferClick, rawFetchData) => (
    <>
        <div className='offersTransfers__ribon'>
            <FormattedText value="offers-transfers_modalRibbon" />
        </div>
        <FormattedText className="offersTransfers_bodytext" value="offers-transfers_modalSubTitle" injectedStrings={data.subtitleWithBetterDeal} />
        <dl className="offersTransfers__itemscontainer">
            {
                data.offers.map((item, index) => (
                    <ProductOffersItem data={item} onClick={onOfferClick} rawFetchData={rawFetchData} index={index} />
                ))
            }
        </dl>
        <div className='offersTransfers__leavewarning'>
            <OKMessage type="informative">
                <FormattedText value="offers-transfers_modalLeaveProcessWarning" />
            </OKMessage>
        </div>
        <ul className='offersTransfers__examplelist'>
            {data.examples.map(item => (
                <li className='offersTransfers__exampleitem'>
                    {item}
                </li>
            ))}

        </ul>
    </>
)
const ProductOffersModal = (props) => {
    const { data, onOfferClick, onPrimaryButtonClick, rawFetchData, open, immFlagBasedFeatures, onCloseCallback } = props;

    React.useEffect(() => {
        if (open) {
            recordLinkV2({
                categoriaEvento: "modal transferencia de deposito",
                accionEvento: "vista",
                action: "open",
                format: "modal",
                component: "modal/transferDeposit",
                element: "full"
            })
        }
    }, [open])

    const handleOfferClick = (offerData) => {
        onOfferClick(offerData)
    }
    const handlePrimaryButtonClick = () => {
        recordLinkV2({
            categoriaEvento: "modal transferencia de deposito",
            accionEvento: "clickButton",
            etiquetaEvento: "continuar con la transferencia",
            action: "click",
            format: "button",
            component: "modal/transferDeposit",
            element: "continueWithTransfer"
        })
        onPrimaryButtonClick()
    }
    const handleCloseModal = () => {
        recordLinkV2({
            categoriaEvento: "modal transferencia de deposito",
            accionEvento: "cerrar",
            action: "close",
            format: "cross",
            component: "modal/transferDeposit",
            element: "close"
        })
        onCloseCallback()
    }

    const renderBanner = () => {
        if (__CONTACT_CENTER__) {
            return (
                <div className="block-info">
                    <i className="block-info__icon-assistant"></i>
                    <FormattedText value='offers-transfers_modalBlockInfo' />
                </div>
            )
        }
        return (
            <RiskProduct
                immFlagBasedFeatures={immFlagBasedFeatures}
                isAlertLiquidity={true}
            />
        )
    }
    return (
        <>
            {data.offers.length > 0 && (
                <OKModal
                    onCloseCallback={handleCloseModal}
                    content={modalContent(data, handleOfferClick, rawFetchData)}
                    size="large"
                    contentOverflow="auto"
                    overlayClassName="offersTransfers__modalOverride"
                    headerType="custom"
                    headerContent={
                        <>
                            {renderBanner()}
                            <h3 className="offersTransfers__title">
                                <FormattedText
                                    value="offers-transfers_modalTitle"
                                    injectedStrings={data.title}
                                />
                            </h3>
                        </>
                    }
                    isOpen={open}
                    titleAlignment="center"
                    contentFooter={
                        <div className="offersTransfers__footer">
                            <OKButton onClick={handlePrimaryButtonClick}>
                                <FormattedText value="offers-transfers_modalPrimaryButton" />
                            </OKButton>
                        </div>
                    }
                />
            )}
        </>
    );
}
ProductOffersModal.propTypes = {
    handleClick: PropTypes.func,
    immProfile: PropTypes.object,
    data: PropTypes.object,
}

module.exports.constructor = ProductOffersModal;
module.exports.ProductOffersModal = ProductOffersModal
